// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#contentBoxWrapper{width:100%;font-family:var(--common-source-sans-pro)}", "",{"version":3,"sources":["webpack://./src/js/components/contentBox.scss"],"names":[],"mappings":"AAAA,mBACE,UAAA,CACA,yCAAA","sourcesContent":["#contentBoxWrapper {\n  width: 100%;\n  font-family: var(--common-source-sans-pro);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
